module.exports = __webpack_public_path__ + "static/media/Norman D. Finch Jr.@2x.14a67c40.jpg";